import { Alert, AlertProps } from '@mui/material';
import { useCurrency } from '@procureai/ui-mui';
import Decimal from 'decimal.js';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

import { useBudgetComparison } from './BudgetAlert.hooks';

export type BudgetAlertProps = {
  budget: Decimal | null;
  quotedValue: Decimal | null;
};

export const BudgetAlert: React.FC<BudgetAlertProps & AlertProps> = ({ budget, quotedValue, ...props }) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeBudgetStep' });
  const { format } = useCurrency();
  const { isQuotedValueOverBudget, difference } = useBudgetComparison({ budget, quotedValue });

  if (isQuotedValueOverBudget === null) {
    return null;
  }
  const differenceFormatted = format(difference.toNumber());
  const severity = isQuotedValueOverBudget ? 'warning' : 'success';
  const message = isQuotedValueOverBudget
    ? t('alert.overBudget', { difference: differenceFormatted })
    : t('alert.withinBudget', { difference: differenceFormatted });

  return (
    <Alert {...props} severity={severity}>
      {message}
    </Alert>
  );
};
